var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.dataList },
          on: { "selection-change": _vm.onSelectionChange },
        },
        [
          _vm._l(
            _vm.config,
            function ({ type, prop, label, width, slot, align, fixed }) {
              return [
                type
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        label: label,
                        type: type,
                        "min-width": width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        fixed: fixed,
                        align: align,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "afterNo"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "itemN",
                                          style: { zIndex: 100 - scope.$index },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content":
                                                  "space-between",
                                                width: "98%",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 订单编号：" +
                                                          _vm._s(
                                                            scope.row.orderInfo
                                                              .orderNo || "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 下单时间：" +
                                                          _vm._s(
                                                            scope.row.orderInfo
                                                              .payTime || "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 提交时间：" +
                                                          _vm._s(
                                                            scope.row
                                                              .createdTime ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 审核时间：" +
                                                          _vm._s(
                                                            scope.row
                                                              .approveTime ||
                                                              "--"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-dropdown",
                                                    {
                                                      attrs: {
                                                        placement: "bottom",
                                                      },
                                                      on: {
                                                        command: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleCommand(
                                                            $event,
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "el-dropdown-link",
                                                          staticStyle: {
                                                            color: "#4168e7",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(" 更多"),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-arrow-down el-icon--right",
                                                            staticStyle: {
                                                              color: "#4168e7",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-dropdown-menu",
                                                        {
                                                          attrs: {
                                                            slot: "dropdown",
                                                          },
                                                          slot: "dropdown",
                                                        },
                                                        [
                                                          _c(
                                                            "el-dropdown-item",
                                                            {
                                                              attrs: {
                                                                command: "1",
                                                              },
                                                            },
                                                            [_vm._v("查看")]
                                                          ),
                                                          scope.row.status ==
                                                            1 &&
                                                          scope.row.afterType !=
                                                            0
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "2",
                                                                  },
                                                                },
                                                                [_vm._v("审核")]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 5
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "3",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "换货寄出"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 6
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "4",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "修改换货单号"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 3
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "5",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "退货单号"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 4
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "6",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "修改退货单号"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 4
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "7",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "查看退货物流"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 6
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "8",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "查看换货物流"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 6
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "9",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "确认收货"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          scope.row.status == 4
                                                            ? _c(
                                                                "el-dropdown-item",
                                                                {
                                                                  attrs: {
                                                                    command:
                                                                      "10",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "确认收货"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " " + _vm._s(scope.row.afterNo) + " "
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "info"
                                  ? _vm._l(
                                      scope.row.orderAfterDetailList,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          { key: index, staticClass: "mesSty" },
                                          [
                                            _c("el-image", {
                                              attrs: {
                                                src: item.goodsImg,
                                                fit: "cover",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "mesFont" },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    attrs: {
                                                      title:
                                                        item.goodsName +
                                                        "*" +
                                                        item.afterQuantity,
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(item.goodsName)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.goodsSkuName
                                                      ) +
                                                      " 数量: " +
                                                      _vm._s(
                                                        item.afterQuantity
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    )
                                  : _vm._e(),
                                slot === "userName"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.userName)
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "ID:" +
                                            _vm._s(scope.row.orderInfo.userId)
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.userPhone)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "postName"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.postName)
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.postPhone)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "address"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              scope.row.orderInfo
                                                .postDistrictAddress
                                            ) +
                                            _vm._s(
                                              scope.row.orderInfo.postAddress
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "orderTypeLabel"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.orderInfo.orderTypeLabel
                                          )
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "status"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title: scope.row.statusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "danger-bg":
                                                  scope.row.status == 99,
                                              },
                                              {
                                                "warning-bg":
                                                  scope.row.status < 4,
                                              },
                                              "round",
                                              {
                                                "success-bg":
                                                  scope.row.status === 6,
                                              },
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.statusLabel) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "price"
                                  ? [
                                      [
                                        scope.row.afterType != 2
                                          ? _c("p", [
                                              _vm._v(
                                                " ￥" +
                                                  _vm._s(
                                                    scope.row.refundMoney
                                                  ) +
                                                  " "
                                              ),
                                            ])
                                          : _c("p", [_vm._v("--")]),
                                      ],
                                    ]
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        align: align,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isInfo,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isInfo = $event
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { "font-size": "20px" } }, [
              _vm._v("是否确认收货?"),
            ]),
            this.typeI == "user"
              ? _c("div", [
                  _vm._v(" 请确认平台用户是否收货，该操作不可修改！ "),
                ])
              : _c("div", [_vm._v("请确认仓库收货，该操作不可修改！")]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isInfo = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.submitInfo } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }